import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, renderSlot as _renderSlot, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1da181f1")

_pushScopeId("data-v-1da181f1")
const _hoisted_1 = { class: "ui__comTitle_main" }
const _hoisted_2 = { class: "ui__comTitle_left" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "ui__comTitle_model" }
const _hoisted_5 = { class: "ui__comTitle_model_title" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 检测标准说明 ")
const _hoisted_7 = { class: "ui__comTitle_model_head" }
const _hoisted_8 = {
  key: 0,
  class: "ui__comTitle_model_cnt"
}
const _hoisted_9 = {
  key: 0,
  class: "prop_up_height"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 1,
  class: "ui__comTitle_model_cnt"
}
const _hoisted_12 = {
  key: 0,
  class: "prop_up_height"
}
const _hoisted_13 = { key: 1 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.state.title) + " ", 1),
      (_ctx.state.title !== 'Комплектация автомобиля' 
            && _ctx.state.title !== 'Базовая информация об автомобиле' 
            && _ctx.state.title !== 'Основная информация об электрической системе'
            && _ctx.state.title !== 'Функциональная комплектация'  
            && _ctx.state.title !== 'Пункты проверки' 
            && _ctx.state.title !== 'Видеообзор автомобиля' )
        ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.state.listSumNumber) + " items", 1))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode("div", {
      class: "ui__comTitle_model_cover",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
    }, null, 512), [
      [_vShow, _ctx.state.isShowModel]
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, [
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("img", {
          src: require('../../../assets/promiseFrame/close.png'),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hiddenModel && _ctx.hiddenModel(...args)))
        }, null, 8, ["src"])
      ]),
      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.state.title), 1),
      (_ctx.state.channelType === 'lingshou')
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.text.slice(0,1), (item, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                (item === 'prop_up_height')
                  ? (_openBlock(), _createBlock("div", _hoisted_9))
                  : (_openBlock(), _createBlock("div", _hoisted_10, _toDisplayString(item), 1))
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_11, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.text, (item, index) => {
              return (_openBlock(), _createBlock("div", { key: index }, [
                (item === 'prop_up_height')
                  ? (_openBlock(), _createBlock("div", _hoisted_12))
                  : (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(item), 1))
              ]))
            }), 128))
          ]))
    ], 512), [
      [_vShow, _ctx.state.isShowModel]
    ]),
    _renderSlot(_ctx.$slots, "default")
  ]))
})